module.exports = __webpack_public_path__ + "images/4fa3ba6e4d117a40073c65db3816fc98d.svg";